import img10 from "../assets/myworks/voyage-connect.png";
import img11 from "../assets/myworks/get-riad.png";
import img12 from "../assets/myworks/modir-auto-ecole-app.png";
import img13 from "../assets/myworks/cosmotiva.png";
import img14 from "../assets/myworks/modir-auto-ecole-landing.png";
import img15 from "../assets/myworks/tiny-tales.png";

export const categories = ["All", "Web App", "Mobile App", "AI"];

export const myWorks = [
  {
    slug: "voyage-connect",
    name: "VoyageConnect",
    shortInfo: "An end-to-end booking product connecting a React interface to Spring Boot services, secure payments, admin operations, and a local AI travel assistant.",
    img: img10,
    imgfull: img10,
    category: "Web App",
    details: {
      client: "Personal Project",
      industry: "Travel / Hospitality",
      tech: "Spring Boot, React 19, MySQL, Stripe, LangChain4j",
      date: "2025",
      duration: "3 months",
      link: null,
      github: null,
    },
    videoDemo: "https://drive.google.com/file/d/1-9RCiL6UWhMfjdeyWIgtx9Kuw9yDLNlD/view?usp=sharing",
    fullDescription:
      "VoyageConnect is a production-ready travel booking platform that allows users to search, book, and manage trips including flights, hotels, and tours. It features a complete checkout flow with Stripe payments, automated email confirmations, PDF invoice generation, and an AI travel assistant chatbot powered by a local Llama 3.2 model via Ollama. The admin dashboard provides analytics and full CRUD management.",
    keyFeatures: [
      "Smart search & filtering by destination, price, date, and type",
      "Secure booking flow with real-time seat availability and Stripe payments",
      "Personal itineraries with drag-and-drop trip builder",
      "PDF invoice generation and booking management",
      "AI travel assistant chatbot via LangChain4j + Ollama",
      "Admin dashboard with revenue analytics and role-based access",
    ],
    techStack: [
      { name: "Spring Boot 3", role: "REST API & business logic" },
      { name: "React 19", role: "Modern SPA frontend" },
      { name: "MySQL", role: "Relational database" },
      { name: "Stripe", role: "Payment processing" },
      { name: "LangChain4j", role: "Local AI chatbot integration" },
      { name: "Docker Compose", role: "Local MySQL + Ollama orchestration" },
    ],
    challenges: [
      "Integrating Stripe payments securely with payment intent confirmation",
      "Setting up local LLM inference with Ollama and LangChain4j",
      "Implementing stateless JWT authentication with Spring Security",
    ],
    results:
      "Built a complete full-stack travel platform demonstrating enterprise-grade patterns: layered architecture, JWT security, third-party payment integration, local AI features, and containerized development environment.",
    gallery: [img10],
  },
  {
    slug: "get-riad",
    name: "Get Riad",
    shortInfo: "A complete React and Firebase modernization that improved the customer experience while preserving the client’s content workflows and business logic.",
    img: img11,
    imgfull: img11,
    category: "Web App",
    details: {
      client: "Get Riad",
      industry: "Real Estate / Construction",
      tech: "React 18, Firebase, Redux, SCSS, Bootstrap",
      date: "2024",
      duration: "2 months",
      link: "https://getriad.com",
      github: null,
    },
    videoDemo: "https://drive.google.com/file/d/1CeYdWJwpGMmp1p3nozdqmiwO3C4tZDSI/view?usp=sharing",
    fullDescription:
      "Get Riad is a production-ready React SPA for a Marrakech-based real estate and riad renovation company. I modernized the entire UI/UX while preserving the existing brand identity and Firebase integrations. The platform showcases luxury riad renovations, construction services, and property sales to a French-speaking clientele with dynamic Firestore content, responsive carousels, and a WhatsApp chat widget.",
    keyFeatures: [
      "Firebase-powered CMS for dynamic projects, testimonials, and blog posts",
      "Hero property search with live filtering and routing",
      "Responsive masonry project galleries with hover zoom effects",
      "Testimonial system with Firestore-backed reviews and submission",
      "WhatsApp floating chat widget for instant client contact",
      "Dark glassmorphism header with backdrop-filter blur",
    ],
    techStack: [
      { name: "React 18", role: "SPA UI & routing" },
      { name: "Firebase", role: "Firestore, Auth, Storage, Hosting" },
      { name: "Redux + Persist", role: "State management & localStorage sync" },
      { name: "SCSS", role: "7-1 architecture with 40+ partials" },
      { name: "Bootstrap 5", role: "Grid system & utilities" },
      { name: "react-slick", role: "Carousels & sliders" },
    ],
    challenges: [
      "Modernizing a legacy HTML-converted template without breaking Firebase data flows",
      "Resolving Material-UI v4 peer dependency conflicts with React 18",
      "Overcoming highly specific legacy SCSS selectors with clean modern overrides",
    ],
    results:
      "Delivered a complete UI modernization with 20 CSS custom properties controlling the entire design system. The glassmorphism header, modern card system, and mobile-first responsive breakpoints elevated the brand perception while all business logic remained intact.",
    gallery: [img11],
  },
  {
    slug: "modir-auto-ecole-app",
    name: "Modir Auto-École",
    shortInfo: "A cross-platform Flutter SaaS product that brings student records, payments, scheduling, analytics, and document generation into one operational system.",
    img: img12,
    imgfull: img12,
    category: "Mobile App",
    details: {
      client: "Modir Auto-École",
      industry: "Education / SaaS",
      tech: "Flutter, Firebase, TypeScript, Cloud Functions",
      date: "2024",
      duration: "4 months",
      link: "https://modir-auto-ecole.web.app",
      github: null,
    },
    fullDescription:
      "Modir Auto-École is a production-grade cross-platform Flutter application that digitizes the entire administrative workflow of a driving school. From enrolling new candidates and tracking their exam progress to generating PDF receipts, contracts, and certificates, the app replaces paper-based processes with a modern cloud-first solution. It features a subscription-based business model with automated trial enforcement via Firebase Functions.",
    keyFeatures: [
      "Real-time dashboard with aggregated stats and interactive fl_chart charts",
      "Full CRUD student lifecycle management with exam progression tracking",
      "Financial management: payments, expenses, dossier fees, monthly revenue",
      "PDF document generation: receipts, contracts, completion certificates",
      "Exam calendar planner with table_calendar integration",
      "Vehicle fleet tracking with insurance renewal alerts",
      "Tri-lingual support (French, Arabic RTL, English) with dark mode",
      "Subscription gating with automated trial expiration via Cloud Functions",
    ],
    techStack: [
      { name: "Flutter 3", role: "Cross-platform mobile & web UI" },
      { name: "Firebase Firestore", role: "Real-time database & user-scoped data" },
      { name: "Firebase Auth", role: "Email/password authentication" },
      { name: "Cloud Functions v2", role: "Serverless aggregations & trial expiry" },
      { name: "Provider", role: "State management" },
      { name: "pdf + printing", role: "Native PDF document generation" },
    ],
    challenges: [
      "Designing Firestore pagination with cursor-based loading and composite filtering",
      "Implementing serverless dashboard aggregations via onDocumentWritten triggers",
      "Building a cross-platform PDF pipeline that works on Android, iOS, and Web",
    ],
    results:
      "Shipped on 3 platforms (Android, iOS, Web) with a complete subscription business model. The real-time aggregation engine eliminates costly client-side queries, and the PDF document system replaced all paper-based processes for driving schools.",
    gallery: [img12],
  },
  {
    slug: "cosmotiva",
    name: "Cosmotiva",
    shortInfo: "A Flutter product that turns cosmetic labels into structured, personalized ingredient insights through a focused Google Gemini workflow.",
    img: img13,
    imgfull: img13,
    category: "AI",
    details: {
      client: "Personal Project",
      industry: "Health & Beauty / AI",
      tech: "Flutter, Firebase, Google Gemini, Riverpod",
      date: "2025",
      duration: "2 months",
      link: null,
      github: null,
    },
    videoDemo: "https://drive.google.com/file/d/1-FVWiKPjPQHjCfuQH24Q22MVNOt0GZ5i/view",
    fullDescription:
      "Cosmotiva is a premium mobile application that empowers users to make informed decisions about their cosmetic products. By snapping a photo of a product label, users receive an instant AI-driven analysis of every ingredient personalized to their skin type and allergy profile. The app features a daily credit system with rewarded video ads, alternative product suggestions, and a glassmorphic dark UI.",
    keyFeatures: [
      "Smart ingredient scanning from camera or gallery with real-time preprocessing",
      "AI-powered personalized analysis via Google Gemini 2.5 Pro",
      "Alternative product suggestions when harmful ingredients are detected",
      "Favorites and scan history synced across sessions via Firestore",
      "Daily credit system with rewarded ads for sustainable monetization",
      "Premium glassmorphic UI with neon violet & teal accents",
    ],
    techStack: [
      { name: "Flutter 3", role: "Cross-platform mobile UI" },
      { name: "Riverpod", role: "State management & dependency injection" },
      { name: "Google Gemini", role: "AI ingredient analysis via REST API" },
      { name: "Firebase", role: "Auth, Firestore, Storage" },
      { name: "Clean Architecture", role: "Domain / Data / Presentation separation" },
      { name: "Google Mobile Ads", role: "Rewarded video monetization" },
    ],
    challenges: [
      "Engineering secure prompt engineering for structured JSON responses from Gemini",
      "Implementing atomic Firestore transactions for the credit system to prevent race conditions",
      "Managing API keys securely with flutter_secure_storage",
    ],
    results:
      "Built a production-quality AI mobile app demonstrating Clean Architecture, generative AI integration, mobile monetization UX, and secure credential management. The credit system offers fair value exchange while gating premium AI usage.",
    gallery: [img13],
  },
  {
    slug: "modir-auto-ecole-landing",
    name: "Modir Auto-École Landing",
    shortInfo: "A multilingual Next.js acquisition experience that connects product positioning to a secure, OTP-verified registration and trial flow.",
    img: img14,
    imgfull: img14,
    category: "Web App",
    details: {
      client: "Modir Auto-École",
      industry: "SaaS / Marketing",
      tech: "Next.js 15, TypeScript, Tailwind CSS, Firebase",
      date: "2025",
      duration: "1.5 months",
      link: "https://modirautoecole.com",
      github: null,
    },
    fullDescription:
      "A conversion-optimized, tri-lingual marketing site with a full OTP-verified registration funnel built for the Modir Auto-École SaaS product. The landing page features 7 animated sections with Framer Motion, Facebook Pixel conversion tracking, and a WhatsApp floating button. The registration flow includes email OTP verification, multi-step form wizard, and server-side Firebase Admin SDK account creation with automatic 15-day trial provisioning.",
    keyFeatures: [
      "High-converting landing page with Framer Motion scroll animations",
      "Multi-step OTP-verified registration funnel (5 steps)",
      "Server-side user creation via Firebase Admin SDK",
      "Tri-lingual support (English, French, Arabic) with RTL layouts",
      "Facebook Pixel integration for CompleteRegistration tracking",
      "WhatsApp floating action button for instant lead capture",
    ],
    techStack: [
      { name: "Next.js 15", role: "App Router, SSR, API routes" },
      { name: "TypeScript", role: "Type safety across frontend and backend" },
      { name: "Tailwind CSS", role: "Utility-first responsive styling" },
      { name: "shadcn/ui", role: "Accessible UI primitives" },
      { name: "Firebase", role: "Auth, Firestore, Admin SDK" },
      { name: "Resend API", role: "Transactional OTP email delivery" },
    ],
    challenges: [
      "Architecting a secure OTP flow with 5-minute TTL expiry in Firestore",
      "Implementing RTL layout mirroring for Arabic with dynamic dir attributes",
      "Handling newline-safe Firebase Admin private key storage in environment variables",
    ],
    results:
      "Delivered a complete user acquisition funnel that reduces fake signups via email verification and auto-provisions 15-day trials. The tri-lingual architecture opens the product to Arabic, French, and English-speaking markets across Morocco and beyond.",
    gallery: [img14],
  },
  {
    slug: "tiny-tales",
    name: "TinyTales",
    shortInfo: "A cross-platform storytelling app coordinating AI text, generated cover art, local persistence, and text-to-speech in one child-friendly experience.",
    img: img15,
    imgfull: img15,
    category: "AI",
    details: {
      client: "Personal Project",
      industry: "Education / Entertainment / AI",
      tech: "Flutter, Google Gemini, Pollinations.ai, Hive",
      date: "2025",
      duration: "1.5 months",
      link: null,
      github: null,
    },
    videoDemo: "https://drive.google.com/file/d/1bVQtXzWb2wP7eZgN8x723Qr3BsMjcdiH/view",
    fullDescription:
      "TinyTales is a cross-platform Flutter application that crafts personalized children's stories using AI. Parents or kids fill out a playful wizard choosing a hero, sidekick, challenge, theme, and narrative style, and the app generates a unique 3-paragraph story paired with a custom cover illustration. Stories are saved locally in a charming bookshelf library and can be read aloud with kid-friendly text-to-speech in a paginated book viewer.",
    keyFeatures: [
      "4-step story wizard for personalizing every narrative",
      "AI story generation via Google Gemini 2.0 Flash",
      "AI cover art creation via Pollinations.ai Flux model",
      "Local bookshelf library with Hive persistence and grid UI",
      "Paginated book reader with text-to-speech (slower pace, higher pitch)",
      "Daily reminder notifications at 7:30 PM to encourage reading",
      "Built-in sharing via share_plus and playful confetti animations",
    ],
    techStack: [
      { name: "Flutter", role: "Cross-platform UI (Android, iOS, Web, Desktop)" },
      { name: "Google Gemini", role: "AI story generation" },
      { name: "Pollinations.ai", role: "Cover image generation" },
      { name: "Hive", role: "Local NoSQL database for story persistence" },
      { name: "flutter_tts", role: "Kid-friendly text-to-speech" },
      { name: "flutter_animate", role: "Declarative UI animations" },
    ],
    challenges: [
      "Synchronizing parallel async text and image generation with error handling",
      "Designing a Hive schema with custom TypeAdapters and file-system image storage",
      "Configuring cross-platform TTS with platform-specific audio session settings",
    ],
    results:
      "Created a delightful, child-first AI app that demonstrates parallel async orchestration, local data persistence with custom adapters, cross-platform TTS configuration, and notification scheduling with exact alarm permissions.",
    gallery: [img15],
  },
];
